/** Small pieces of the labelling report (pages/LabellingPage.tsx): a bar of the four levels, and the legend that names them. */

import { SENSITIVITIES, type LevelCounts } from '@aioe/shared';

import './labelling.css';

export const LEVEL_WORDS: Record<(typeof SENSITIVITIES)[number], string> = { public: 'Public', internal: 'Internal', confidential: 'Confidential', restricted: 'Restricted' };

export function LevelLegend({ extra }: { extra?: { label: string; colour: string }[] }) {
  return (
    <ul className="lbl__legend" aria-hidden="true">
      {SENSITIVITIES.map((l) => (
        <li key={l} style={{ ['--key' as string]: `var(--level-${l})` }}>
          <i className="lbl__key" />
          {LEVEL_WORDS[l]}
        </li>
      ))}
      {(extra ?? []).map((e) => (
        <li key={e.label} style={{ ['--key' as string]: e.colour }}>
          <i className="lbl__key" />
          {e.label}
        </li>
      ))}
    </ul>
  );
}

/** The levels as one bar, each segment as wide as its share; the words say every figure for a screen reader and a hover. */
export function LevelBar({ counts, small, label }: { counts: LevelCounts; small?: boolean; label: string }) {
  const total = SENSITIVITIES.reduce((n, l) => n + counts[l], 0);
  const words = SENSITIVITIES.filter((l) => counts[l] > 0)
    .map((l) => `${counts[l].toLocaleString('en-AU')} ${LEVEL_WORDS[l].toLowerCase()}`)
    .join(', ');
  return (
    <div className={`lbl-bar ${small ? 'lbl-bar--small' : ''}`} role="img" aria-label={`${label}: ${total ? words : 'none'}`} title={`${label}: ${total ? words : 'none'}`}>
      {SENSITIVITIES.map((l) => (counts[l] > 0 ? <span key={l} style={{ flexGrow: counts[l], ['--seg' as string]: `var(--level-${l})` }} /> : null))}
    </div>
  );
}

export const n = (v: number) => v.toLocaleString('en-AU');
